var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDetyratTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.2 20",
    style: {
      enableBackground: "new 0 0 22.2 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000130615147645718039340000001940184571261041076_);}\r\n\t.st3{clip-path:url(#SVGID_00000081634595598250897940000013946659566164430746_);}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#BDB6B8;}\r\n\t.st6{fill:#1A1A1A;}\r\n\t.st7{fill:#ADA8AA;}\r\n\t.st8{fill:#262424;}\r\n\t.st9{fill:#1E8273;}\r\n\t.st10{fill:#239281;}\r\n\t.st11{fill:#262626;}\r\n\t.st12{fill:#0F0F0F;}\r\n\t.st13{fill:#212226;}\r\n\t.st14{opacity:0.25;}\r\n\t.st15{clip-path:url(#SVGID_00000147902265065797746470000000950458959576866217_);}\r\n\t.st16{opacity:0.15;}\r\n\t.st17{clip-path:url(#SVGID_00000137818447696860063650000009987073030969580969_);}\r\n\t\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4171_00000070798949537746889240000010340651942030331532_",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4170_00000165937525434866985520000014923681067384462471_",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7415_00000134212190235252654350000000058067522740290455_",
    className: "st1",
    d: "M20,0H2.2C1,0,0,1,0,2.2v15.6 C0,19,1,20,2.2,20H20c1.2,0,2.2-1,2.2-2.2V2.2C22.2,1,21.2,0,20,0z M7.8,15.6H4.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h3.3 c0.6,0,1.1,0.5,1.1,1.1S8.4,15.6,7.8,15.6z M7.8,11.1H4.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h3.3c0.6,0,1.1,0.5,1.1,1.1 S8.4,11.1,7.8,11.1z M7.8,6.7H4.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h3.3c0.6,0,1.1,0.5,1.1,1.1S8.4,6.7,7.8,6.7z M18.6,9 L15,12.5c-0.4,0.4-1.1,0.4-1.6,0L11.9,11c-0.4-0.4-0.4-1.1,0-1.6s1.1-0.4,1.6,0l0.8,0.8L17,7.4c0.4-0.4,1.1-0.4,1.6,0c0,0,0,0,0,0 l0,0C19,7.9,19,8.6,18.6,9L18.6,9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetyratTasks);
export default __webpack_public_path__ + "static/media/icon_detyrat_tasks.5d722c74d353baf43dab4f0bf38fce1f.svg";
export { ForwardRef as ReactComponent };